import { render, staticRenderFns } from "./dangerStorageCheckItemPop.vue?vue&type=template&id=63df699b"
import script from "./dangerStorageCheckItemPop.vue?vue&type=script&lang=js"
export * from "./dangerStorageCheckItemPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63df699b')) {
      api.createRecord('63df699b', component.options)
    } else {
      api.reload('63df699b', component.options)
    }
    module.hot.accept("./dangerStorageCheckItemPop.vue?vue&type=template&id=63df699b", function () {
      api.rerender('63df699b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/base/dangerStorageCheckItemPop.vue"
export default component.exports